import { useEffect } from 'react';
import { FaHeart, FaArrowRight, FaSearch, FaCalendarCheck } from 'react-icons/fa';
import banner from '../../assets/images/banner.jpg';

export default function Header() {
    useEffect(() => {
        // Create the script element
        const script = document.createElement('script');
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WHWCQ2C7');`;

        // Append the script to the head or body
        document.head.appendChild(script);

        // Clean up the script when the component unmounts
        return () => {
            document.head.removeChild(script);
        };
    }, []); // Empty dependency array ensures this runs only once after the component mounts

    return (
        <header className="header-container" style={{ backgroundImage: `url(${banner})` }}>
            <div className="hero-overlay"></div>
            <div className="hero-content">
                <div className="hero-badge" data-aos={'fade-down'}>
                    <FaHeart className="badge-icon" />
                    <span>Mental Health Clinic</span>
                </div>
                
                <h1 className="hero-title" data-aos={'fade-down'} data-aos-delay="100">
                    Your Journey to Wellness
                    <span className="title-highlight">Starts Here</span>
                </h1>
                
                <p className="hero-description" data-aos={'fade-up'} data-aos-delay="200">
                    Welcome to <strong>Your Journey Counseling and Wellness</strong> where we believe that 
                    <em> YOUR journey is personal and to be respected</em>. 
                    Let us help you reach your destination one step at a time.
                </p>
                
                <div className="hero-features" data-aos="fade-up" data-aos-delay="300">
                    <div className="feature-item">
                        <div className="feature-icon">✓</div>
                        <span>Personalized Care</span>
                    </div>
                    <div className="feature-item">
                        <div className="feature-icon">✓</div>
                        <span>Expert Therapists</span>
                    </div>
                    <div className="feature-item">
                        <div className="feature-icon">✓</div>
                        <span>Compassionate Support</span>
                    </div>
                </div>
                
                <div className="hero-cta" data-aos="zoom-in" data-aos-delay="400">
                    <h4 className="cta-title">Schedule Your First Appointment</h4>
                    <div className="header-buttons">
                        <a href="#Therapists" className='btn-appointment btn-primary'>
                            <FaSearch className="btn-icon" />
                            <span>Find Therapists</span>
                            <FaArrowRight className="btn-arrow" />
                        </a>
                        <a href="#Therapists" className='btn-appointment btn-secondary'>
                            <FaCalendarCheck className="btn-icon" />
                            <span>Book Appointment</span>
                            <FaArrowRight className="btn-arrow" />
                        </a>
                    </div>
                </div>
            </div>
            
            <div className="hero-scroll-indicator">
                <div className="scroll-mouse">
                    <div className="scroll-wheel"></div>
                </div>
                <span>Scroll to explore</span>
            </div>
        </header>
    );
}

